<template>
  <div>
    <form
      class="form"
      method="POST"
      action="javascript:;"
      @submit.prevent="submit"
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <FormLoading v-if="!formReady" />

      <CardBase v-else>
        <template #header>{{ $route.meta.title }}</template>
        <template #content>
          <FormRow class="mb-4" :required="true">
            <template #label>Name</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.name.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Asset name"
                v-model.trim="formData.name"
                v-focus
              />
              <div
                class="form-error"
                v-if="$v.formData.name.$error && formSubmitted"
              >
                <span class="form-error__text" v-if="!$v.formData.name.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Asset Group</template>
            <template #field>
              <multiselect
                deselectLabel=""
                :multiple="true"
                :options="listGroup"
                :loading="listGroupLoading"
                :class="$v.formData.groups.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="code_name"
                placeholder="Choose group"
                v-model="formData.groups"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.groups.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.groups.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <!-- <FormRow class="mt-4">
            <template #label>Nexus API Merchant Code</template>
            <template #field>
              <input
                type="text"
                class="form__input"
                placeholder="Nexus API Merchant Code"
                v-model.trim="formData.merchant_code"
              />
            </template>
          </FormRow>

          <FormRow class="mt-4">
            <template #label>Nexus API Salt</template>
            <template #field>
              <input
                type="text"
                class="form__input"
                placeholder="Nexus API Salt"
                v-model.trim="formData.salt"
              />
            </template>
          </FormRow>

          <FormRow class="mt-4">
            <template #label>Nexus Sync URL</template>
            <template #field>
              <input
                type="text"
                class="form__input"
                placeholder="Nexus Sync URL"
                v-model.trim="formData.sync_url"
              />
            </template>
          </FormRow> -->

          <FormDataLog :data="formData" v-if="!formCreate" />
        </template>

        <template #footer>
          <FormRow class="mb-0">
            <template #field>
              <BaseButton type="submit">Submit</BaseButton>
            </template>
            <template #link>
              <div class="ml-4">
                or
                <router-link :to="{ name: 'AssetList' }" class="link ml-2"
                  >Back to List Assets</router-link
                >
              </div>
            </template>
          </FormRow>
        </template>
      </CardBase>
    </form>

    <Changelog v-if="!this.formCreate" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  components: {
    Multiselect,
  },
  mixins: [submitFormMixin],
  data: () => {
    return {
      listGroup: [],
      listGroupLoading: true,
      formData: {
        sync: 0,
      },
    };
  },
  computed: {
    getLoggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
  },
  created() {
    if (this.formCreate) this.formData.sync = 0;
    this.getListGroup();
  },
  methods: {
    getListGroup() {
      this.listGroupLoading = true;
      this.$http.get(process.env.VUE_APP_API_URL + "/group").then((res) => {
        if (res.status == 200) {
          const response = res.data;

          if (response) {
            this.listGroup = response.data;
            this.listGroupLoading = false;
          }
        }
      });
    },
  },
  validations: {
    formData: {
      name: {
        required,
      },
      groups: {
        required,
      },
    },
  },
};
</script>
